module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.state.selectedTags.length > 0) ? _c('button', {
    staticClass: "btn btn-danger tag-delete-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.deleteTags()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-trash"
  }), _vm._v("\n    Delete " + _vm._s(_vm.tagNormalized) + "\n  ")]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /home/abuild/rpmbuild/BUILD/Portus-master/~/vue-loader/lib/template-compiler?{"id":"data-v-fa9b852c"}!/home/abuild/rpmbuild/BUILD/Portus-master/~/vue-loader/lib/selector.js?type=template&index=0!./modules/repositories/components/delete-tag-action.vue
// module id = 88
// module chunks = 0